import Link from 'next/link';
import React from 'react';
import { Compostable } from 'shared/Icon';
import { AllergenDairy, AllergenGluten } from 'shared/Icon/Dietary/AllergenIcons';
import {
  DietaryHalal,
  DietaryKosher,
  DietaryLowFODMAP,
  DietaryOrganic,
  DietaryPaleo,
  DietaryVegan,
  DietaryVegetarian,
  DietaryWhole30,
} from 'shared/Icon/Dietary/DietaryIcons';
import { DietaryTags } from 'utils/constants';
import { DietaryFilterButton } from 'utils/dietary-util';

const dietaryTagToIcon: Record<DietaryTags, React.ReactNode> = {
  [DietaryTags.VEGETARIAN]: <DietaryVegetarian />,
  [DietaryTags.VEGAN]: <DietaryVegan />,
  [DietaryTags.GLUTEN_FREE]: <AllergenGluten isCrossed={false} />,
  [DietaryTags.DAIRY_FREE]: <AllergenDairy isCrossed={false} />,
  [DietaryTags.PALEO]: <DietaryPaleo />,
  [DietaryTags.LOW_FODMAP]: <DietaryLowFODMAP />,
  [DietaryTags.WHOLE30]: <DietaryWhole30 />,
  [DietaryTags.HALAL]: <DietaryHalal />,
  [DietaryTags.ORGANIC]: <DietaryOrganic />,
  [DietaryTags.COMPOSTABLE]: <Compostable />,
  [DietaryTags.KOSHER]: <DietaryKosher />,
};

interface IProps {
  className?: string;
  href: string;
  item: DietaryFilterButton;
  active?: boolean;
}

export const DietaryButton: React.FC<IProps> = ({ className, href, item, active }) => (
  <Link
    href={href}
    className={`flex min-w-fit cursor-pointer flex-row items-center rounded-lg border bg-white p-4 ${
      active ? 'border-radish-200 shadow-[0_0_14px_rgba(0,0,0,0.1)]' : 'border-neutral-500'
    } ${className}`}>
    <div className='mr-4 text-lg'>{dietaryTagToIcon[item.name]}</div>
    <span className='text-xs font-bold text-neutral-700'>{item.name}</span>
  </Link>
);
